import Renderer from "./Renderer.js";
import moment from 'moment';

class ShortDatetimeRenderer extends Renderer {
    render() {
        if ((!this.data || this.data <= '0001-01-01')) {
            return '';
        } else if (this.data) {
            return moment(this.data).format('DD-MM HH:mm')
        }
        return '';
    }
}

export default ShortDatetimeRenderer;
